//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//TODO: 如果实体对应的数据库表已经存在数据记录，则不允许修改引用实体，防止数据错乱！！

export default {
  name: 'SimpleTable',
  props: {
    tableWidth: [String, Number],
    columns: Array,
    data: Array,
    showPagination: {
      type: Boolean,
      default: true
    },
    showCheckBox: {
      type: Boolean,
      default: false
    },
    pagination: Object,
    height: {
      type: String,
      default: '100%'
    },
    maxHeight: {
      type: Number,
      default: 2000
    },
    tableSize: {
      type: String,
      default: 'large'
    },
    showOperationColumn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.$emit('handleSizeChange', val);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.$emit('handleCurrentChange', val);
    },
    formatterValue: function formatterValue(row, column, cellValue) {
      return cellValue;
    }
  }
};